import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import Icon, { type IconName } from 'components/icon/Icon';

import { IButton } from 'source/NFR.types';

export const buttonThemes = defineTheme({
  primary: 'button--theme-primary',
  secondary: 'button--theme-secondary',
  signal: 'button--theme-signal',
  dropdown: 'button--theme-dropdown',
  large: 'button--theme-large',
  small: 'button--theme-small',
  light: 'button--theme-light',

  // Legacy theme kept for backwards compatibility.
  link: 'button--theme-link'
});
export type ButtonTheme = ThemeKeys<typeof buttonThemes>;

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, IButton {
  icon?: IconName;
  iconBeforeChildren?: IconName;
  theme?: ButtonTheme | ButtonTheme[];
  iconFill?: boolean;
  isLink?: boolean;
  isDropdown?: boolean;
}

const Button: React.FC<React.PropsWithChildren<ButtonProps>> = ({
  className,
  children,
  icon: iconProp,
  iconBeforeChildren,
  text,
  theme = [],
  type = 'button',
  iconFill = false,
  isLink,
  isDropdown,
  ...props
}) => {
  const icon = isDropdown ? 'arrow-down-wide' : iconProp;

  return (
    <button
      {...props}
      type={type}
      className={cn('button', className, buttonThemes(theme), {
        'button--has-children': !!children || !!text,
        'button--has-icon-left': iconBeforeChildren,
        'button--has-icon-right': icon,
        'button--theme-link': isLink,
        'button--theme-dropdown': isDropdown
      })}
    >
      {iconBeforeChildren && <Icon fill={iconFill} name={iconBeforeChildren} />}
      {children}
      {text}
      {icon && <Icon fill={iconFill} name={icon} />}
    </button>
  );
};

Button.displayName = 'Button';

export default Button;
